import BN from 'bignumber.js';

export async function executeMethod(method: any, args: any[], context: any, padding = 1.25): Promise<any> {
  const gas = await method.estimateGas(...args, context);

  context.gas = new BN(Math.round(gas * padding));

  return method(...args, context);
}
